const FeaturesSchedulingBlock = {
    blockData: {
        id: 'scheduling',
        image: 'marketing_site/features-hub/desktop/full_images/scheduling_calendar.png',
        link: '/meeting-scheduler'
    }
};

export default FeaturesSchedulingBlock;
